export default "__VITE_ASSET__4iHKqkqa__"